/** The composer-and-fixes round (2026-11-03, rule 11): another forum member's post on a customer's topic (author kind "other"). The member is
 *  neither the topic's author (the customer) nor a moderator; the site names them and OmnaBase keeps the name and the site's host on the
 *  message (`delivery.participant`), never a customer row. The thread shows the post on the customer's side as "<name> · on <host>" with the
 *  mark "Also on the topic". */
export type OtherParticipant = { name: string; host: string };

/** the words the thread shows beside another participant's post */
export const OTHER_PARTICIPANT_MARK = "Also on the topic";

/** the participant kept on a message's delivery record, or null when it names none */
export function participantOf(delivery: unknown): OtherParticipant | null {
  const p = (delivery as { participant?: { name?: unknown; host?: unknown } } | null | undefined)?.participant;
  if (!p || typeof p.name !== "string" || !p.name.trim()) return null;
  return { name: p.name, host: typeof p.host === "string" ? p.host : "" };
}

/** how the thread names the post: "<name> · on <host>" (the name alone when the host is unknown) */
export const participantLabel = (p: OtherParticipant): string => (p.host ? `${p.name} · on ${p.host}` : p.name);
